import { DataTestIds } from '@repo/frontend-shared';
import { SDSDialog } from '@repo/sds/SDSDialog';
import { SDSText } from '@repo/sds/SDSText';

import './ConfirmationModal.scss';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  description?: string;
  buttonText: string;
  title?: string;
  size?: 'small' | 'medium' | 'large' | 'fullscreen';
  isConfirming?: boolean;
}

export function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  description,
  buttonText,
  title = '',
  size = 'medium',
  isConfirming = false,
}: ConfirmationModalProps) {
  return (
    <SDSDialog
      isOpen={isOpen}
      onClose={onClose}
      className="ConfirmationModal"
      dataTestId={DataTestIds.MODALS.CONFIRMATION.CONTAINER}
      title={title}
      size={size}
      primaryAction={{
        label: buttonText,
        onClick: onConfirm,
        dataTestId: DataTestIds.MODALS.CONFIRMATION.CONFIRM_BTN,
        status: 'alert',
        ariaLabel: `Confirm: ${buttonText}`,
        loading: isConfirming,
      }}
      secondaryAction={{
        dataTestId: DataTestIds.MODALS.CONFIRMATION.CANCEL_BTN,
        onClick: onClose,
        label: 'Cancel',
        ariaLabel: 'Cancel action',
      }}
    >
      {description && <SDSText type="body-medium" text={description} />}
    </SDSDialog>
  );
}
